import { AdminCollectionEditor } from '../../_Shared/_UI/AdminCollectionEditor';
import { AdminViewLayout } from '../../_Shared/_UI/AdminViewLayout';
import { ADMIN_DEFAULT_ORDER, ADMIN_VISIBILITY_FILTER } from '../../_Shared/_Config/AdminCollectionFilters';
import { SOCIALS_ADMIN_API as API } from '../_MODULES/_API';
import '../../_Shared/_UI/_Styles/PortfolioAdmin.css';

const SOCIAL_FILTERS = [
    ADMIN_VISIBILITY_FILTER,
    {
        key: 'network_filter',
        field: 'network',
        label: 'Redes',
        type: 'multi',
        placeholder: 'Seleccionar redes…',
    },
];

export const SocialsViewMain = () => (
    <AdminViewLayout
        pageKey="socials"
        title="Redes sociales"
        description="Define enlaces a GitHub, LinkedIn, X, YouTube, tu web u otras redes. Se muestran en el footer; LinkedIn queda como canal publico de contacto."
    >
        <AdminCollectionEditor
            title="Redes y perfiles"
            listEndpoint={API.LIST}
            saveEndpoint={API.SAVE}
            removeEndpoint={API.REMOVE}
            titleField="label"
            subtitleField="url"
            searchFields={['network', 'label', 'url', 'handle']}
            filters={SOCIAL_FILTERS}
            orderOptions={ADMIN_DEFAULT_ORDER('label')}
            fields={[
                { name: 'network', label: 'Clave (github, linkedin, twitter, youtube...)' }, { name: 'label', label: 'Etiqueta visible' },
                { name: 'url', label: 'URL', span: 2 }, { name: 'handle', label: 'Usuario / handle' },
                { name: 'sort_order', label: 'Orden', type: 'number', defaultValue: 0 }, { name: 'active', label: 'Visible', type: 'checkbox', defaultValue: true },
            ]}
        />
    </AdminViewLayout>
);
